import { setFetchStartState } from '../fetchLoadable';
import { createNotLoaded } from '../Loadable/utils';
import * as actionTypes from './actionTypes';
export const integrationsReducer = (state = {}, action) => {
    const { type, payload = {} } = action;
    switch (type) {
        case actionTypes.FETCH_INTEGRATION_START:
            return Object.assign(Object.assign({}, state), { [payload.id]: Object.assign({}, setFetchStartState(state[payload.id], payload.res)) });
        case actionTypes.FETCH_INTEGRATION_ERROR:
        case actionTypes.FETCH_INTEGRATION_SUCCESS:
            return Object.assign(Object.assign({}, state), { [payload.id]: Object.assign({}, payload.res) });
        default:
            return state;
    }
};
export const integrationListReducer = (state = createNotLoaded(), action) => {
    const { type, payload = {} } = action;
    switch (type) {
        case actionTypes.FETCH_INTEGRATIONS_START:
            return Object.assign({}, setFetchStartState(state, payload.res));
        case actionTypes.FETCH_INTEGRATIONS_SUCCESS:
        case actionTypes.FETCH_INTEGRATIONS_ERROR:
            return Object.assign({}, payload.res);
        default:
            return state;
    }
};
export const integrationActivationReducer = (state = {}, action) => {
    const { type, payload = {} } = action;
    switch (type) {
        case actionTypes.FETCH_INTEGRATION_ACTIVATION_START:
            return Object.assign(Object.assign({}, state), { [payload.id]: Object.assign({}, setFetchStartState(state[payload.id], payload.res)) });
        case actionTypes.FETCH_INTEGRATION_ACTIVATION_SUCCESS:
        case actionTypes.FETCH_INTEGRATION_ACTIVATION_ERROR:
            return Object.assign(Object.assign({}, state), { [payload.id]: Object.assign({}, payload.res) });
        default:
            return state;
    }
};
export const creditorIntegrationActivationsReducer = (state = {}, action) => {
    const { type, payload } = action;
    switch (type) {
        case actionTypes.FETCH_CREDITOR_INTEGRATIONS_ACTIVATIONS_START:
            return Object.assign(Object.assign({}, state), { [payload.creditorId]: Object.assign({}, setFetchStartState(state[payload.creditorId], payload.res)) });
        case actionTypes.FETCH_CREDITOR_INTEGRATIONS_ACTIVATIONS_SUCCESS:
        case actionTypes.FETCH_CREDITOR_INTEGRATIONS_ACTIVATIONS_ERROR:
            return Object.assign(Object.assign({}, state), { [payload.creditorId]: Object.assign({}, payload.res) });
        default:
            return state;
    }
};
export const missingApplicationsReducer = (state = {}, action) => {
    const { type, payload } = action;
    switch (type) {
        case actionTypes.FETCH_MISSING_APPLICATIONS_START:
            return Object.assign(Object.assign({}, state), { [payload.creditorId]: Object.assign({}, setFetchStartState(state[payload.creditorId], payload.res)) });
        case actionTypes.FETCH_MISSING_APPLICATIONS_SUCCESS:
        case actionTypes.FETCH_MISSING_APPLICATIONS_ERROR:
            return Object.assign(Object.assign({}, state), { [payload.creditorId]: Object.assign({}, payload.res) });
        default:
            return state;
    }
};
//# sourceMappingURL=reducer.js.map